'use strict';

/*!--------------------------------------------------------------------
JAVASCRIPT "Outdated Browser"
Version:    1.1.0 - 2014
author:     Burocratik
website:    http://www.burocratik.com
* @preserve
-----------------------------------------------------------------------*/
var outdatedBrowser = function outdatedBrowser(options) {

    //Variable definition (before ajax)
    var outdated = document.getElementById("outdated");

    // Default settings
    this.defaultOpts = {
        bgColor: '#f25648',
        color: '#ffffff',
        lowerThan: 'transform',
        languagePath: '../outdatedbrowser/lang/en.html'
    };

    if (options) {
        //assign css3 property to IE browser version
        if (options.lowerThan == 'IE8' || options.lowerThan == 'borderSpacing') {
            options.lowerThan = 'borderSpacing';
        } else if (options.lowerThan == 'IE9' || options.lowerThan == 'boxShadow') {
            options.lowerThan = 'boxShadow';
        } else if (options.lowerThan == 'IE10' || options.lowerThan == 'transform' || options.lowerThan == '' || typeof options.lowerThan === "undefined") {
            options.lowerThan = 'transform';
        } else if (options.lowerThan == 'IE11' || options.lowerThan == 'borderImage') {
            options.lowerThan = 'borderImage';
        }
        //all properties
        this.defaultOpts.bgColor = options.bgColor;
        this.defaultOpts.color = options.color;
        this.defaultOpts.lowerThan = options.lowerThan;
        this.defaultOpts.languagePath = options.languagePath;

        bkgColor = this.defaultOpts.bgColor;
        txtColor = this.defaultOpts.color;
        cssProp = this.defaultOpts.lowerThan;
        languagePath = this.defaultOpts.languagePath;
    } else {
        bkgColor = this.defaultOpts.bgColor;
        txtColor = this.defaultOpts.color;
        cssProp = this.defaultOpts.lowerThan;
        languagePath = this.defaultOpts.languagePath;
    }; //end if options


    //Define opacity and fadeIn/fadeOut functions
    var done = true;

    function function_opacity(opacity_value) {
        outdated.style.opacity = opacity_value / 100;
        outdated.style.filter = 'alpha(opacity=' + opacity_value + ')';
    }

    // function function_fade_out(opacity_value) {
    //     function_opacity(opacity_value);
    //     if (opacity_value == 1) {
    //         outdated.style.display = 'none';
    //         done = true;
    //     }
    // }

    function function_fade_in(opacity_value) {
        function_opacity(opacity_value);
        if (opacity_value == 1) {
            outdated.style.display = 'block';
        }
        if (opacity_value == 100) {
            done = true;
        }
    }

    //check if element has a particular class
    // function hasClass(element, cls) {
    //     return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    // }

    var supports = function () {
        var div = document.createElement('div'),
            vendors = 'Khtml Ms O Moz Webkit'.split(' '),
            len = vendors.length;

        return function (prop) {
            if (prop in div.style) return true;

            prop = prop.replace(/^[a-z]/, function (val) {
                return val.toUpperCase();
            });

            while (len--) {
                if (vendors[len] + prop in div.style) {
                    return true;
                }
            }
            return false;
        };
    }();

    //if browser does not supports css3 property (transform=default), if does > exit all this
    if (!supports('' + cssProp + '')) {
        if (done && outdated.style.opacity !== '1') {
            done = false;
            for (var i = 1; i <= 100; i++) {
                setTimeout(function (x) {
                    return function () {
                        function_fade_in(x);
                    };
                }(i), i * 8);
            }
        }
    } else {
        return;
    }; //end if

    //Check AJAX Options: if languagePath == '' > use no Ajax way, html is needed inside <div id="outdated">
    if (languagePath === ' ' || languagePath.length == 0) {
        startStylesAndEvents();
    } else {
        grabFile(languagePath);
    }

    //events and colors
    function startStylesAndEvents() {
        var btnClose = document.getElementById("btnCloseUpdateBrowser");
        var btnUpdate = document.getElementById("btnUpdateBrowser");

        //check settings attributes
        outdated.style.backgroundColor = bkgColor;
        //way too hard to put !important on IE6
        outdated.style.color = txtColor;
        outdated.children[0].style.color = txtColor;
        outdated.children[1].style.color = txtColor;

        //check settings attributes
        btnUpdate.style.color = txtColor;
        // btnUpdate.style.borderColor = txtColor;
        if (btnUpdate.style.borderColor) btnUpdate.style.borderColor = txtColor;
        btnClose.style.color = txtColor;

        //close button
        btnClose.onmousedown = function () {
            outdated.style.display = 'none';
            return false;
        };

        //Override the update button color to match the background color
        btnUpdate.onmouseover = function () {
            this.style.color = bkgColor;
            this.style.backgroundColor = txtColor;
        };
        btnUpdate.onmouseout = function () {
            this.style.color = txtColor;
            this.style.backgroundColor = bkgColor;
        };
    } //end styles and events


    // IF AJAX with request ERROR > insert english default
    var ajaxEnglishDefault = '<h6>Your browser is out-of-date!</h6>' + '<p>Update your browser to view this website correctly. <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">Update my browser now </a></p>' + '<p class="last"><a href="#" id="btnCloseUpdateBrowser" title="Close">&times;</a></p>';

    //** AJAX FUNCTIONS - Bulletproof Ajax by Jeremy Keith **
    function getHTTPObject() {
        var xhr = false;
        if (window.XMLHttpRequest) {
            xhr = new XMLHttpRequest();
        } else if (window.ActiveXObject) {
            try {
                xhr = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    xhr = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {
                    xhr = false;
                }
            }
        }
        return xhr;
    }; //end function

    function grabFile(file) {
        var request = getHTTPObject();
        if (request) {
            request.onreadystatechange = function () {
                displayResponse(request);
            };
            request.open("GET", file, true);
            request.send(null);
        }
        return false;
    }; //end grabFile

    function displayResponse(request) {
        var insertContentHere = document.getElementById("outdated");
        if (request.readyState == 4) {
            if (request.status == 200 || request.status == 304) {
                insertContentHere.innerHTML = request.responseText;
            } else {
                insertContentHere.innerHTML = ajaxEnglishDefault;
            }
            startStylesAndEvents();
        }
        return false;
    }; //end displayResponse

    ////////END of outdatedBrowser function
};
"use strict";

/*
 CSS Browser Selector 0.81
 Originally written by Rafael Lima (http://rafael.adm.br)
 http://rafael.adm.br/css_browser_selector
 License: http://creativecommons.org/licenses/by/2.5/

 Co-maintained by:
 https://github.com/ridjohansen/css_browser_selector
 https://github.com/delka/css_browser_selector
 https://github.com/verbatim/css_browser_selector
 */
(function () {
	var uaInfo = {
		ua: '',
		is: function is(t) {
			return RegExp(t, "i").test(uaInfo.ua);
		},
		version: function version(p, n) {
			n = n.replace(".", "_");
			var i = n.indexOf('_'),
			    ver = "";
			while (i > 0) {
				ver += " " + p + n.substring(0, i);
				i = n.indexOf('_', i + 1);
			}
			ver += " " + p + n;
			return ver;
		},
		getBrowser: function getBrowser() {
			var g = 'gecko',
			    w = 'webkit',
			    c = 'chrome',
			    f = 'firefox',
			    s = 'safari',
			    o = 'opera',
			    ua = uaInfo.ua,
			    is = uaInfo.is;

			return [!/opera|webtv/i.test(ua) && /msie\s(\d+)/.test(ua) ? 'ie ie' + (/trident\/4\.0/.test(ua) ? '8' : RegExp.$1) : is('edge\/') ? 'edge ie' + (/edge\/(\d+)\.(\d+)/.test(ua) ? RegExp.$1 + ' ie' + RegExp.$1 + '_' + RegExp.$2 : '') // IE Edge
			: is('trident\/') ? 'ie ie' + (/trident\/.+rv:(\d+)/i.test(ua) ? RegExp.$1 : '') //ie11+
			: is('firefox/') ? g + " " + f + (/firefox\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + f + RegExp.$2 + ' ' + f + RegExp.$2 + "_" + RegExp.$4 : '') : is('gecko/') ? g : is('opera') ? o + (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + o + RegExp.$2 + ' ' + o + RegExp.$2 + "_" + RegExp.$4 : /opera(\s|\/)(\d+)\.(\d+)/.test(ua) ? ' ' + o + RegExp.$2 + " " + o + RegExp.$2 + "_" + RegExp.$3 : '') : is('konqueror') ? 'konqueror' : is('chrome') ? w + ' ' + c + (/chrome\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + c + RegExp.$2 + (RegExp.$4 > 0 ? ' ' + c + RegExp.$2 + "_" + RegExp.$4 : '') : '') : is('iron') ? w + ' iron' : is('applewebkit/') ? w + ' ' + s + (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? ' ' + s + RegExp.$2 + " " + s + RegExp.$2 + RegExp.$3.replace('.', '_') : / Safari\/(\d+)/i.test(ua) ? RegExp.$1 == "419" || RegExp.$1 == "417" || RegExp.$1 == "416" || RegExp.$1 == "412" ? ' ' + s + '2_0' : RegExp.$1 == "312" ? ' ' + s + '1_3' : RegExp.$1 == "125" ? ' ' + s + '1_2' : RegExp.$1 == "85" ? ' ' + s + '1_0' : '' : '') : //applewebkit
			is('mozilla/') ? g : ''];
		},
		getPlatform: function getPlatform() {
			var wp = 'winphone',
			    a = 'android',
			    bb = 'blackberry',
			    dv = 'device_',
			    ua = uaInfo.ua,
			    version = uaInfo.version,
			    is = uaInfo.is;

			return [is('j2me') ? 'j2me' : is('windows phone') ? wp + (/Windows Phone (\d+)(\.(\d+))+/i.test(ua) ? " " + wp + RegExp.$1 + " " + wp + RegExp.$1 + RegExp.$2.replace('.', '_') : /Windows Phone OS (\d+)(\.(\d+))+/i.test(ua) ? " " + wp + RegExp.$1 + " " + wp + RegExp.$1 + RegExp.$2.replace('.', '_') : '') : // Windows Phone
			is('blackberry') ? bb + (/Version\/(\d+)(\.(\d+)+)/i.test(ua) ? " " + bb + RegExp.$1 + " " + bb + RegExp.$1 + RegExp.$2.replace('.', '_') : /Blackberry ?(([0-9]+)([a-z]?))[\/|;]/gi.test(ua) ? ' ' + bb + RegExp.$2 + (RegExp.$3 ? ' ' + bb + RegExp.$2 + RegExp.$3 : '') : '') : // blackberry
			is('android') ? a + (/Version\/(\d+)(\.(\d+))+/i.test(ua) ? " " + a + RegExp.$1 + " " + a + RegExp.$1 + RegExp.$2.replace('.', '_') : '') + (/Android (.+); (.+) Build/i.test(ua) ? ' ' + dv + RegExp.$2.replace(/ /g, "_").replace(/-/g, "_") : '') : //android
			is('ipad|ipod|iphone') ? (/CPU( iPhone)? OS (\d+[_|\.]\d+([_|\.]\d+)*)/i.test(ua) ? 'ios' + version('ios', RegExp.$2) : '') + ' ' + (/(ip(ad|od|hone))/gi.test(ua) ? RegExp.$1 : "") : //'iphone'
			//:is('ipod')?'ipod'
			//:is('ipad')?'ipad'
			is('playbook') ? 'playbook' : is('kindle|silk') ? 'kindle' : is('playbook') ? 'playbook' : is('mac') ? 'mac' + (/mac os x ((\d+)[.|_](\d+))/.test(ua) ? ' mac' + RegExp.$2 + ' mac' + RegExp.$1.replace('.', "_") : '') : is('win') ? 'win' + (is('windows nt 10.0') ? ' win10' : is('windows nt 6.3') ? ' win8_1' : is('windows nt 6.2') ? ' win8' : is('windows nt 6.1') ? ' win7' : is('windows nt 6.0') ? ' vista' : is('windows nt 5.2') || is('windows nt 5.1') ? ' win_xp' : is('windows nt 5.0') ? ' win_2k' : is('windows nt 4.0') || is('WinNT4.0') ? ' win_nt' : '') : is('freebsd') ? 'freebsd' : is('x11|linux') ? 'linux' : ''];
		},
		getMobile: function getMobile() {
			var is = uaInfo.is;
			return [is("android|mobi|mobile|j2me|iphone|ipod|ipad|blackberry|winphone|playbook|kindle|silk") ? 'mobile' : ''];
		},
		getIpadApp: function getIpadApp() {
			var is = uaInfo.is;
			return [is('ipad|iphone|ipod') && !is('safari') ? 'ipad_app' : ''];
		},
		getLang: function getLang() {
			var ua = uaInfo.ua;

			return [/[; |\[](([a-z]{2})(\-[a-z]{2})?)[)|;|\]]/i.test(ua) ? ('lang_' + RegExp.$2).replace("-", "_") + (RegExp.$3 != '' ? (' ' + 'lang_' + RegExp.$1).replace("-", "_") : '') : ''];
		}
	};

	if (typeof html == 'undefined') {
		var html = document.documentElement;
	}

	var screenInfo = {
		width: (window.outerWidth || html.clientWidth) - 15,
		height: window.outerHeight || html.clientHeight,
		screens: [0, 768, 980, 1200],

		screenSize: function screenSize() {
			screenInfo.width = (window.outerWidth || html.clientWidth) - 15;
			screenInfo.height = window.outerHeight || html.clientHeight;

			var screens = screenInfo.screens,
			    i = screens.length,
			    arr = [],
			    maxw,
			    minw;

			while (i--) {
				if (screenInfo.width >= screens[i]) {
					if (i) {
						arr.push("minw_" + screens[i]);
					}
					if (i <= 2) {
						arr.push("maxw_" + (screens[i + 1] - 1));
					}
					break;
				}
			}
			return arr;
		},
		getOrientation: function getOrientation() {
			return screenInfo.width < screenInfo.height ? ["orientation_portrait"] : ["orientation_landscape"];
		},
		getInfo: function getInfo() {
			var arr = [];
			arr = arr.concat(screenInfo.screenSize());
			arr = arr.concat(screenInfo.getOrientation());
			return arr;
		},
		getPixelRatio: function getPixelRatio() {
			var arr = [],
			    pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;

			if (pixelRatio > 1) {
				arr.push('retina_' + parseInt(pixelRatio) + 'x');
				arr.push('hidpi');
			} else {
				arr.push('no-hidpi');
			}
			return arr;
		}
	};

	var dataUriInfo = {
		data: new Image(),
		div: document.createElement("div"),
		isIeLessThan9: false,
		getImg: function getImg() {

			dataUriInfo.data.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
			dataUriInfo.div.innerHTML = "<!--[if lt IE 9]><i></i><![endif]-->";
			dataUriInfo.isIeLessThan9 = dataUriInfo.div.getElementsByTagName("i").length == 1;

			return dataUriInfo.data;
		},
		checkSupport: function checkSupport() {
			if (dataUriInfo.data.width != 1 || dataUriInfo.data.height != 1 || dataUriInfo.isIeLessThan9) {
				return ["no-datauri"];
			} else {
				return ["datauri"];
			}
		}

	};

	function css_browser_selector(u, ns) {
		var html = document.documentElement,
		    b = [];
		ns = ns ? ns : "";

		/* ua */
		uaInfo.ua = u.toLowerCase();
		b = b.concat(uaInfo.getBrowser());
		b = b.concat(uaInfo.getPlatform());
		b = b.concat(uaInfo.getMobile());
		b = b.concat(uaInfo.getIpadApp());
		b = b.concat(uaInfo.getLang());

		/* js */
		b = b.concat(['js']);

		/* pixel ratio */
		b = b.concat(screenInfo.getPixelRatio());

		/* screen */
		b = b.concat(screenInfo.getInfo());

		var updateScreen = function updateScreen() {
			html.className = html.className.replace(/ ?orientation_\w+/g, "").replace(/ [min|max|cl]+[w|h]_\d+/g, "");
			html.className = html.className + ' ' + screenInfo.getInfo().join(' ');
		};

		if (window.addEventListener) {
			window.addEventListener('resize', updateScreen);
			window.addEventListener('orientationchange', updateScreen);
		} else if (window.attachEvent) {
			window.attachEvent('onresize', updateScreen);
		}

		/* dataURI */
		var data = dataUriInfo.getImg();
		data.onload = data.onerror = function () {
			html.className += ' ' + dataUriInfo.checkSupport().join(' ');
		};

		/* save & add existing html classes */
		var classes = html.className;
		var classesArray = classes.split(/ /);

		/* merge existing classes on html tag */
		b = b.concat(classesArray);

		/* removendo itens invalidos do array */
		/* add filter function polyfill for IE8 */
		if (!Array.prototype.filter) {
			Array.prototype.filter = function (fun /*, thisArg*/) {
				'use strict';

				if (this === void 0 || this === null) {
					throw new TypeError();
				}

				var t = Object(this);
				var len = t.length >>> 0;
				if (typeof fun !== 'function') {
					throw new TypeError();
				}

				var res = [];
				var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
				for (var i = 0; i < len; i++) {
					if (i in t) {
						var val = t[i];

						// NOTE: Technically this should Object.defineProperty at
						//			 the next index, as push can be affected by
						//			 properties on Object.prototype and Array.prototype.
						//			 But that method's new, and collisions should be
						//			 rare, so use the more-compatible alternative.
						if (fun.call(thisArg, val, i, t)) {
							res.push(val);
						}
					}
				}

				return res;
			};
		}

		b = b.filter(function (e) {
			/* if no-js class exists, remove it */
			if (e === 'no-js') {
				return false;
			}
			return e;
		});

		/* prefixo do namespace */
		b[0] = ns ? ns + b[0] : b[0];
		html.className = b.join(' ' + ns);
		return html.className;
	}

	// Add css_browser_selector as a global object.
	window.css_browser_selector = css_browser_selector;
})();

// define css_browser_selector_ns before loading this script to assign a namespace
var css_browser_selector_ns = css_browser_selector_ns || "";

// init
css_browser_selector(navigator.userAgent, css_browser_selector_ns);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// [Friendly Name, lowercase, API_Value]

var user_type = [['Candidate', 'candidate', 0], ['Employer', 'employer', 1]];

var employment_types = [['Contract', 'contract', 'Contract'], ['Contract To Hire', 'contract to hire', 'Contract+To+Hire'], ['Direct Hire', 'direct hire', 'Direct+Hire']];

var industries = [['Accounting', 'accounting', 'C11090'], ['Administrative', 'administrative', 'C44735'], ['Healthcare', 'healthcare', 'C69043'],
// ['Human Resources', 'human resources', 'C50950'],
['IT', 'IT', 'C11089']];

var employer_pages = [['Finance and Accounting', 'finance and accounting', '/clients/finance-and-accounting'], ['Information Technology', 'information technology', '/clients/information-technology'], ['Administrative and Human Resources', 'administrative and human resources', '/clients/administrative-human-resources'], ['Non Clinical Healthcare', 'non clinical healthcare', '/clients/non-clinical']];

var createVNode = Inferno.createVNode;
var Form = function () {
  var Component = Inferno.Component;

  var startsWithVowel = function startsWithVowel(string) {
    return ['a', 'e', 'i', 'o', 'u'].indexOf(string.toLowerCase()[0]) !== -1;
  };
  var toSentence = function toSentence(arr) {
    return arr.length > 2 ? arr.slice(0, -2).join(', ') + (arr.slice(0, -2).length ? ', ' : '') + arr.slice(-2).join(', and ') : arr.join(' and ');
  };

  var Choice = function (_Component) {
    _inherits(Choice, _Component);

    function Choice(props) {
      _classCallCheck(this, Choice);

      var _this = _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).call(this, props));

      _this.clickHandler = _this.clickHandler.bind(_this);
      return _this;
    }

    _createClass(Choice, [{
      key: 'clickHandler',
      value: function clickHandler() {
        this.props.event(this.props.subject, this.props.values);
      }
    }, {
      key: 'render',
      value: function render() {
        var text = this.props.values[1];
        var selected = !!this.props.selected;
        return createVNode(2, 'li', selected ? 'selected' : '', createVNode(2, 'a', null, text, {
          'href': '#',
          'onClick': this.clickHandler
        }));
      }
    }]);

    return Choice;
  }(Component);

  var Toggle = function (_Choice) {
    _inherits(Toggle, _Choice);

    function Toggle(props) {
      _classCallCheck(this, Toggle);

      var _this2 = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

      _this2.clickHandler = _this2.clickHandler.bind(_this2);
      return _this2;
    }

    _createClass(Toggle, [{
      key: 'clickHandler',
      value: function clickHandler() {
        this.props.event(this.props.subject, this.props.values, this.props.value);
      }
    }, {
      key: 'render',
      value: function render() {
        var text = this.props.values[1];
        var selected = !!this.props.selected;
        return createVNode(2, 'li', selected ? 'toggle selected' : 'toggle', createVNode(2, 'a', null, text, {
          'href': '#',
          'onClick': this.clickHandler
        }));
      }
    }]);

    return Toggle;
  }(Choice);

  var Link = function (_Choice2) {
    _inherits(Link, _Choice2);

    function Link(props) {
      _classCallCheck(this, Link);

      return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
    }

    _createClass(Link, [{
      key: 'render',
      value: function render() {
        var text = this.props.values[1];
        var selected = !!this.props.selected;
        var url = this.props.values[2];
        return createVNode(2, 'li', selected ? 'selected' : '', createVNode(2, 'a', null, text, {
          'href': url
        }));
      }
    }]);

    return Link;
  }(Choice);

  var App = function (_Component2) {
    _inherits(App, _Component2);

    function App(props) {
      _classCallCheck(this, App);

      var _this4 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

      _this4.state = {
        step: 0,
        value: '',
        who: ['', '', ''],
        seeking: {},
        industry: [],
        keyword: [''],
        responseData: ''
      };

      _this4.toggleModal = _this4.toggleModal.bind(_this4);
      _this4.dismiss = _this4.dismiss.bind(_this4);
      _this4.setChoice = _this4.setChoice.bind(_this4);
      _this4.setToggle = _this4.setToggle.bind(_this4);
      _this4.inputChange = _this4.inputChange.bind(_this4);
      // this.step = this.step.bind(this);
      _this4.generateRequestUrl = _this4.generateRequestUrl.bind(_this4);
      _this4.submit = _this4.submit.bind(_this4);
      return _this4;
    }

    _createClass(App, [{
      key: 'toggleModal',
      value: function toggleModal() {
        this.setState({
          modal: !this.state.modal
        });
      }
    }, {
      key: 'dismiss',
      value: function dismiss(direction) {
        var _this5 = this;

        var curStep = this.state.step;
        var delta = direction && direction < 0 ? direction : 1;

        this.setState({
          modal: false
        });

        setTimeout(function () {
          _this5.setState({
            step: _this5.stepCap(curStep, delta)
          });
        }, 500);
      }
    }, {
      key: 'stepCap',
      value: function stepCap(step, delta) {
        var newStep = step + delta;
        var limit = 4;
        return newStep >= limit ? 0 : newStep;
      }
    }, {
      key: 'setChoice',
      value: function setChoice(key, value) {
        this.setState(_defineProperty({}, key, value));

        this.dismiss();
      }
    }, {
      key: 'setToggle',
      value: function setToggle(group, key, value) {
        var cleanKey = key[1];
        var currentToggleState = this.state[group] ? !!this.state[group][cleanKey] : false;
        var setValue = typeof value === "boolean";

        var mutableToggleState = Object.assign(this.state[group] || {}, _defineProperty({}, cleanKey, setValue ? value : !currentToggleState));

        this.setState(_defineProperty({}, group, mutableToggleState));
      }
    }, {
      key: 'inputChange',
      value: function inputChange(event) {
        var target = event.target;
        var type = target.type;
        var name = target.name;
        var snowflake = target.dataset.snowflake;
        var value = type === 'checkbox' ? target.checked : target.value;

        this.setState(_defineProperty({}, name, snowflake === 'user_type' ? user_type[value] : [value, value, value]));
      }

      // step(int) {
      //   this.setState({
      //     step: int || this.state.step++
      //   });
      // }

    }, {
      key: 'generateRequestUrl',
      value: function generateRequestUrl(seekArray, indArray, keyword) {
        var urlBase = 'http://jobs.tewscompany.com/index.smpl';
        // const urlBase = '/jobs/';

        var categories = indArray.map(function (indString) {
          return industries.find(function (industry) {
            return industry[1] === indString;
          })[2];
        });
        var catParam = '&category=';
        var catRawString = encodeURIComponent(categories.join('|'));
        var catParamString = catParam + categories.join(catParam);

        var emTypes = seekArray.map(function (emString) {
          return employment_types.find(function (employment) {
            return employment[1] === emString;
          })[2];
        });
        var emTypeParam = '&POST_EMPLOYMENT_TYPE=';
        var emTypeParamString = emTypeParam + emTypes.join(emTypeParam).replace(/ /g, '+');

        // const time = 1513618225 //new Date().getTime();
        // const hash = '31dd78d9e2a6e0c41f97c05dc1b108dd';

        var keywordString = keyword ? encodeURIComponent(keyword) : '';

        return urlBase + '?ref_arg=list_posts&pp=20&pid=gwt&first=0&total=0&action=1&save=0&order_select_mobile=26' + ('&rawcats=' + catRawString + catParamString + emTypeParamString + '&keyword=' + keywordString);
      }
    }, {
      key: 'submit',
      value: function submit(event) {
        alert('A name was submitted: ' + this.state.value);
        event.preventDefault();
        this.goTo();
      }
    }, {
      key: 'goTo',
      value: function goTo(url) {
        window.location.href = url;
        console.log(url, this);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this6 = this;

        var step = this.state.step;

        // Grammar booleans
        var shouldAn = startsWithVowel(this.state.who[1]);
        var employer = this.state.who[1] === 'employer';

        var whoString = this.state.who[1];
        var keywordString = this.state.keyword[1];

        var seekingArray = Object.keys(this.state.seeking).filter(function (key) {
          return _this6.state.seeking[key];
        });
        var seekingString = seekingArray.join(',');
        var seekingGrammarString = toSentence(seekingArray);

        var industryArray = Object.keys(this.state.industry).filter(function (key) {
          return _this6.state.industry[key];
        });
        var industryString = industryArray.join(',');
        var industryGrammarString = toSentence(industryArray);
        var shouldPluralize = industryArray.length > 1;

        // const seekingArray = Object.keys(this.state.seeking).map(key => this.state.seeking[key])
        // const seekingGrammarString = toSentence(seekingArray);

        // Booleans for whether a given step has a valid value
        // This determines when to show the next/submit buttons
        // Use true for non-required fields (like the keyword input)
        var stepState = [!!whoString, !!seekingGrammarString, !!industryGrammarString, true];

        // Generate a valid request URL when user is on the last step
        var requestUrl = step === 3 && stepState[step] ? this.generateRequestUrl(seekingArray, industryArray, this.state.keyword[1]) : '';

        // Form Input Arrays
        var userTypes = user_type.map(function (user) {
          return createVNode(16, Choice, null, null, {
            'subject': 'who',
            'values': user,
            'event': _this6.setChoice,
            'selected': whoString === user[1]
          });
        });

        var employerPages = employer_pages.map(function (employment) {
          return createVNode(16, Link, null, null, {
            'subject': 'seeking',
            'values': employment,
            'selected': !!_this6.state.seeking[employment[1]]
          });
        });

        var employmentChoices = employment_types.map(function (employment) {
          return createVNode(16, Toggle, null, null, {
            'subject': 'seeking',
            'values': employment,
            'event': _this6.setToggle,
            'selected': !!_this6.state.seeking[employment[1]]
          });
        });

        var industryChoices = industries.map(function (industry) {
          return createVNode(16, Toggle, null, null, {
            'subject': 'industry',
            'values': industry,
            'event': _this6.setToggle,
            'selected': !!_this6.state.industry[industry[1]]
          });
        });

        return createVNode(2, 'form', this.state.modal ? 'modal' : '', [createVNode(2, 'h2', 'sentence', [createVNode(2, 'span', null, ['I am a', shouldAn ? 'n' : '', ' ', this.state.who[1], ' ']), createVNode(2, 'span', null, ['seeking ', employer ? 'help in ' : '', seekingGrammarString, ' positions ']), createVNode(2, 'span', null, ['in the field', shouldPluralize ? 's' : '', ' of ', industryGrammarString, ' ']), createVNode(2, 'span', null, ['as a ', this.state.keyword[1] || '..', '.'])]), createVNode(2, 'div', 'modal_el', null, {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'field_wrapper', createVNode(2, 'div', 'field_group', [createVNode(2, 'fieldset', step === 0 ? 'active' : '' /*{ this.state.who[0] ? 'selected' : 'undecided'*/, createVNode(2, 'label', null, [createVNode(2, 'span', 'h1 string', ['I am a', shouldAn ? 'n' : ''], {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'input_box h1', [createVNode(2, 'span', whoString ? 'inter active' : 'inter', whoString), createVNode(2, 'hr', 'line')], {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'abyss', [createVNode(2, 'ul', null, userTypes), createVNode(2, 'div', 'controls', [createVNode(2, 'a', 'back', null, {
          'href': '#',
          'onClick': function onClick() {
            return _this6.dismiss(-1);
          }
        }), createVNode(2, 'a', 'close', 'Close', {
          'href': '#',
          'onClick': this.toggleModal
        }), createVNode(2, 'a', 'next', 'Next', {
          'href': '#',
          'onClick': this.dismiss
        })]), createVNode(2048, 'select', null, user_type.map(function (user_type) {
          return createVNode(2, 'option', null, user_type[0], {
            'value': user_type[2]
          });
        }), {
          'name': 'who',
          'onInput': this.inputChange,
          'data-snowflake': 'user_type'
        })])])), createVNode(2, 'fieldset', step === 1 ? 'active' : '' /*{ seekingArray.length ? 'selected' : 'undecided'*/, createVNode(2, 'label', null, [createVNode(2, 'span', 'h1 string', ['seeking ', employer ? 'help in ' : ''], {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'input_box h1', [createVNode(2, 'span', seekingGrammarString ? 'inter active' : 'inter', seekingGrammarString), createVNode(2, 'hr', 'line')], {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'abyss', [employer ? createVNode(2, 'ul', 'page_links', employerPages) : createVNode(2, 'ul', null, employmentChoices), createVNode(2, 'div', 'controls', [createVNode(2, 'a', 'back', 'Back', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.dismiss(-1);
          }
        }), createVNode(2, 'a', 'close', 'Close', {
          'href': '#',
          'onClick': this.toggleModal
        }), !employer && createVNode(2, 'a', 'next', 'Next', {
          'href': '#',
          'onClick': this.dismiss
        })]), createVNode(512, 'input', null, null, {
          'type': 'text',
          'name': 'seeking',
          'value': seekingString
        }), ' '])])), !employer &&
        /* "In the field of [industry]" */
        createVNode(2, 'fieldset', step === 2 ? 'active' : '' /*{ industryArray.length ? 'selected' : 'undecided'*/, createVNode(2, 'label', null, [createVNode(2, 'span', 'h1 string', ['in the field', shouldPluralize ? 's' : '', ' of'], {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'input_box h1', [createVNode(2, 'span', industryGrammarString ? 'inter active' : 'inter', industryGrammarString), createVNode(2, 'hr', 'line')], {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'abyss', [createVNode(2, 'ul', null, industryChoices), createVNode(2, 'div', 'controls', [createVNode(2, 'a', 'back', 'Back', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.dismiss(-1);
          }
        }), createVNode(2, 'a', 'close', 'Close', {
          'href': '#',
          'onClick': this.toggleModal
        }), createVNode(2, 'a', 'next', 'Next', {
          'href': '#',
          'onClick': this.dismiss
        })]), createVNode(512, 'input', null, null, {
          'type': 'text',
          'name': 'industry',
          'value': industryString,
          'onInput': this.inputChange
        })])])), !employer &&
        /* "As a [keyword]" */
        createVNode(2, 'fieldset', step === 3 ? 'active' : '' /*{this.state.keyword[1] ? 'selected' : 'undecided'*/, createVNode(2, 'label', null, [createVNode(2, 'span', 'h1 string', 'as a', {
          'onClick': this.toggleModal
        }), createVNode(2, 'div', 'input_box h1', [createVNode(2, 'span', this.state.keyword[1] ? 'inter active' : 'inter', keywordString), createVNode(2, 'hr', 'line')], {
          'onClick': this.toggleModal
        }), createVNode(66, 'div', null, createVNode(2, 'span', null, this.state.keyword[0] || createVNode(2, 'br')), {
          'contenteditable': 'true',
          'onInput': this.inputChange
        }, null, null, true), createVNode(2, 'div', 'abyss', [createVNode(512, 'input', 'visible keyword h1', null, {
          'type': 'text',
          'name': 'keyword',
          'placeholder': 'job title, skills, job id, etc.',
          'value': this.state.keyword[2],
          'onInput': this.inputChange
        }), createVNode(2, 'div', 'controls', [createVNode(2, 'a', 'back', 'Back', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.dismiss(-1);
          }
        }), createVNode(2, 'a', 'close', 'Close', {
          'href': '#',
          'onClick': this.toggleModal
        }), createVNode(2, 'a', 'next', 'Submit', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.goTo(requestUrl);
          }
        })])])]))], {
          'style': { transform: 'translate3d(-' + step + '00%,0,0)' }
        })), createVNode(2, 'div', 'global controls', [createVNode(2, 'a', step === 0 ? 'close' : 'hidden', 'Close', {
          'href': '#',
          'onClick': function onClick() {
            return $('#app_root').toggleClass('app_on');
          }
        }), createVNode(2, 'a', step > 0 ? 'back' : 'hidden', 'Back', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.setState({ step: _this6.stepCap(step, -1) });
          }
        }), createVNode(2, 'a', step < 3 && stepState[step] ? 'next' : 'hidden', 'Next', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.setState({ step: _this6.stepCap(step, 1) });
          }
        }), createVNode(2, 'a', step === 3 && stepState[step] ? 'submit' : 'hidden', 'Submit', {
          'href': '#',
          'onClick': function onClick() {
            return _this6.goTo(requestUrl);
          }
        })])], {
          'onSubmit': this.submit
        });
      }
    }]);

    return App;
  }(Component);

  return { App: App };
}();
'use strict';

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
var app = {};
var createVNode = Inferno.createVNode;
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function init() {

        // Navigation Stuff
        var $nav = $('#nav');
        var $navToggle = $('#nav_toggle');
        var $subMenuItems = $('#nav .menu-item-has-children');
        var $headerWrapper = $('.header_wrapper');

        var navSuperClass = 'super';
        var navSubModeClass = 'view-sub-menu';
        var navBackClass = 'back';

        $nav.click(function (event) {
          var target = event.target.tagName;
          if (target === 'NAV' || target === 'UL') {
            $subMenuItems.removeClass(navSuperClass);
            $nav.removeClass(navSubModeClass);
            $navToggle.removeClass(navBackClass);
          }
        });

        $navToggle.click(function (event) {
          event.preventDefault();

          if ($navToggle.hasClass(navBackClass)) {
            $subMenuItems.removeClass(navSuperClass);
            $nav.removeClass(navSubModeClass);
            $navToggle.removeClass(navBackClass);
          } else {
            $headerWrapper.toggleClass('visible');
          }
        });

        $subMenuItems.click(function (event) {
          console.log(event);
          if (event.target.tagName === 'LI') {
            var $self = $(this);
            var isSuper = $self.hasClass(navSuperClass);

            $subMenuItems.removeClass(navSuperClass);
            if (!isSuper) {
              $nav.addClass(navSubModeClass);
              $navToggle.addClass(navBackClass);
              $self.addClass(navSuperClass);
            } else {
              $nav.removeClass(navSubModeClass);
              $navToggle.removeClass(navBackClass);
            }
          }
        });
      },
      finalize: function finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }, // Home page
    'home': {
      init: function init() {
        var $content = $('#content');
        var $overlay = $('#overlay');
        var $video_cta_link = $('#video_cta');
        var $video_player = $('#video_player');
        var $video_player_close = $video_player.find('.close');
        var $video_bg = $('#bg_video-right video');

        app.parent_el = document.getElementById('app_root');
        app.el = document.getElementById('form_app');
        app.$button = $('#form_button');

        // Video Player Logic
        var player_open_class = 'player_open';

        $video_cta_link.click(function (event) {
          var mobile = !!document.documentElement.classList.contains('maxw_767');

          event.preventDefault();

          $content.toggleClass(player_open_class);
          window.setTimeout(function () {
            $video_player[0].children[0].play();
          }, 300);
          if (!mobile) {
            // $video_player.addClass('show').show();
          }
        });

        $video_player_close.click(function () {
          $content.removeClass(player_open_class);
          $video_player[0].children[0].pause();
          // $video_player.removeClass('show').hide();
        });

        $overlay.click(function () {
          $content.removeClass(player_open_class);
          $video_player[0].children[0].pause();
        });

        // Fancy Form App
        app.$button.click(function () {
          $(app.parent_el).toggleClass('app_on');
        });

        // Prevent some iOS wierdness
        $video_bg.click(function (event) {
          event.preventDefault();
        });
      },
      finalize: function finalize() {
        app.rt = Inferno.render(createVNode(16, Form.App), app.el);
        console.log(app);
      }
    },
    'page_template_template_team': {
      init: function init() {
        var teamNav = new Swiper('.team_nav_slider', {
          spaceBetween: 10,
          // loop: true,
          // loopedSlides: 2,
          centeredSlides: true,
          slidesPerView: 'auto',
          navigation: {
            prevEl: '.team_control_btn-prev',
            nextEl: '.team_control_btn-next'
          },
          grabCursor: true,
          touchRatio: 0.5,
          slideToClickedSlide: true,
          keyboard: true
        });

        var teamContent = new Swiper('.team_content_slider', {
          spaceBetween: 75,
          // loop: true,
          // loopedSlides: 2,
          simulateTouch: false,
          draggable: false,
          noSwiping: true,
          noSwipingClass: 'no-swipe',
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          breakpoints: {
            768: {
              simulateTouch: true,
              draggable: true,
              noSwiping: false,
              loop: true,
              pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
                // effect: 'slide',
              } }
          }
        });

        if (teamNav.controller && teamContent.controller) {
          teamNav.controller.control = teamContent;
          teamContent.controller.control = teamNav;
        }
      }
    },
    'page_template_template_jobs': {
      init: function init() {
        var typehead = document.getElementById('jb_location_typeahead');
        if (!typehead) return false;

        var scriptArea = typehead.parentElement;
        var loc = window.location;
        var params = new URLSearchParams(loc.search);

        var paramObj = {};
        var paramVals = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var param = _step.value;

            paramObj[param[0]] = param[1];
            paramVals[paramVals.length] = param;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        console.log(paramObj, paramVals);

        if (scriptArea && paramObj.ref_arg) {
          var scriptMarkup = scriptArea.innerHTML;
          var betweenString = this.getStringBetwixt(scriptMarkup, " h: '", "'");
          var hash = betweenString[0];
          var time = this.getStringBetwixt(betweenString[1], " t: '", "'")[0];

          params.append('arg', 'jb_search_results');
          params.append('h', hash);
          params.append('t', time);
          params.delete('ref_arg');

          var newUrl = loc.origin + loc.pathname + '?' + params.toString();

          window.location.replace(newUrl);
        }
      },
      getStringBetwixt: function getStringBetwixt(rawString, stringHead, stringTail) {
        var stringPos = rawString.indexOf(stringHead);
        var string = rawString.slice(stringPos + stringHead.length);
        var stringEnd = string.indexOf(stringTail) - stringTail.length;

        return [string.slice(0, stringEnd), string];
      },
      finalize: function finalize() {}
    }
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function fire(func, funcname, args) {
      var fire = void 0,
          namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function loadEvents() {
      // Fire common init JS
      UTIL.fire('common');
      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        console.log(classnm);
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.